import React from "react";
import SegmentButton from "./SegmentButton";

interface Props {
  labels: string[];
  setActiveIndex: (index: number) => void;
  activeIndex: number;
}

const SegmentSelector = ({ labels, setActiveIndex, activeIndex }: Props) => (
  <div className="container">
    {labels.map((label, index) => (
      <SegmentButton
        key={label}
        setActiveIndex={setActiveIndex}
        index={index}
        label={label}
        activeIndex={activeIndex}
      />
    ))}
    <style jsx>{`
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 1 auto;
        padding: 10px 0;
      }
    `}</style>
  </div>
);

export default SegmentSelector;
